import { htmlSafe } from '@ember/template';

export default function iconColorStyle(color?: string) {
  return color ? htmlSafe(`fill: ${color}; color: ${color};`) : undefined;
}
